import { Editor, Element as SlateElement, Transforms } from "slate";

export const LIST_TYPES = ["numbered-list", "bulleted-list"];
export const TEXT_ALIGN_TYPES = ["left", "center", "right", "justify"];

// ✅ Toggle Block (Paragraph, List, Block-quote, Heading, Alignments)
export const toggleBlock = (editor, format) => {
  const isActive = isBlockActive(
    editor,
    format,
    TEXT_ALIGN_TYPES.includes(format) ? "align" : "type"
  );

  const isList = LIST_TYPES.includes(format);

  Transforms.unwrapNodes(editor, {
    match: n =>
      !Editor.isEditor(n) && SlateElement.isElement(n) &&  (LIST_TYPES.includes(n.type)), split: true
  });

  let newProperties;
  if (TEXT_ALIGN_TYPES.includes(format)) {
    newProperties = { align: isActive ? undefined : format };
  } else {
    newProperties = {
      type: isActive ? "paragraph" : isList ? "list-item" : format
    };
  }
  Transforms.setNodes(editor, newProperties);

  if (!isActive && isList) {
    const block = { type: format, children: [] };
    Transforms.wrapNodes(editor, block);
  }
};

// ✅ Toggle Mark (Bold, Italic, Underline, Code, Color, Link, etc.)
export const toggleMark = (editor, format) => {
  const isActive = isMarkActive(editor, format);

  if (isActive) {
    Editor.removeMark(editor, format);
  } else {
    if (format === 'link') {
      const url = window.prompt('Enter URL:');
      if (url) {
        Editor.addMark(editor, 'link', true);
        Editor.addMark(editor, 'url', url);
      }
    } else {
      Editor.addMark(editor, format, true);
    }
  }
};

// ✅ Check if Block Active (Paragraph, List, Heading, Alignments)
export const isBlockActive = (editor, format, blockType = "type") => {
  const { selection } = editor;
  if (!selection) return false;

  const [match] = Array.from(
    Editor.nodes(editor, {
      at: Editor.unhangRange(editor, selection),
      match: n =>
        !Editor.isEditor(n) &&
        SlateElement.isElement(n) &&
        n[blockType] === format
    })
  );

  return !!match;
};

// ✅ Check if Mark Active (Bold, Italic, Underline, Color, Link, etc.)
export const isMarkActive = (editor, format) => {
  const marks = Editor.marks(editor);
  return marks ? marks[format] === true : false;
};




export const withMentionsAndTags =(editor)=> {
  const { isInline, isVoid } = editor;

  editor.isInline = (element) => {
    if (!element) return isInline(element);
    return element.type === "mention" || element.type === "tag"
      ? true
      : isInline(element);
  };

  editor.isVoid = (element) => {
    if (!element) return isVoid(element);
    return element.type === "mention" || element.type === "tag"
      ? true
      : isVoid(element);
  };

  return editor;
};